/**
 * RefundSlice Notes Reducers
 * 
 * Handles note CRUD operations.
 */

import { CaseReducer, PayloadAction } from '@reduxjs/toolkit';
import { RefundSliceState } from '../state';
import { NoteView } from '../../types/refundTypes';

// Helper function to add field to edited fields array without duplicates
const addEditedField = (state: RefundSliceState, fieldName: string) => {
  if (!state.editedFields.includes(fieldName)) {
    state.editedFields.push(fieldName);
  }
  state.isEdited = true;
};

/**
 * Add a new note
 */
export const addNote: CaseReducer<RefundSliceState, PayloadAction<Omit<NoteView, 'id'>>> = (
  state,
  action
) => {
  if (state.currentRefund) {
    const newNote: NoteView = {
      ...action.payload,
      id: `temp_${Date.now()}`, // Temporary ID until saved
    };
    state.currentRefund.notes.push(newNote);
    addEditedField(state, 'notes');
  }
};

/**
 * Update an existing note
 */
export const updateNote: CaseReducer<
  RefundSliceState,
  PayloadAction<{ noteId: string; updates: Partial<NoteView> }>
> = (state, action) => {
  if (state.currentRefund) {
    const noteIndex = state.currentRefund.notes.findIndex(
      note => note.id === action.payload.noteId
    );
    if (noteIndex !== -1) {
      state.currentRefund.notes[noteIndex] = {
        ...state.currentRefund.notes[noteIndex],
        ...action.payload.updates
      };
      addEditedField(state, 'notes');
    }
  }
};

/**
 * Remove a note by ID
 */
export const removeNote: CaseReducer<RefundSliceState, PayloadAction<string>> = (
  state,
  action
) => {
  if (state.currentRefund) {
    state.currentRefund.notes = state.currentRefund.notes.filter(
      note => note.id !== action.payload
    );
    addEditedField(state, 'notes');
  }
};
